<script setup lang="ts">
import { useAttrs } from 'vue';

const svgAttrs = useAttrs();
</script>

<template>
  <svg
    fill="none"
    height="30"
    viewBox="0 0 30 30"
    width="30"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="svgAttrs"
  >
    <rect
      height="30"
      width="30"
    />
    <path
      d="M21.1011 8.89894V7H11.3995C8.97415 7 7 8.97415 7 11.3995V21.1011H8.89894V23H18.6005C21.0259 23 23 21.0259 23 18.6005V8.89894H21.1011ZM19.2021 16.2503C19.1457 17.134 18.4125 17.8296 17.51 17.8296C17.04 17.8296 16.6075 17.6416 16.3067 17.322C16.1563 17.1904 16.0247 17.0023 15.9495 16.7955C15.9495 16.7767 15.9307 16.7579 15.9307 16.7391C15.9307 16.7015 15.9119 16.6639 15.9119 16.6263C15.8743 16.4759 15.8555 16.3067 15.8367 16.1375C15.8367 16.1187 15.8367 16.0811 15.8367 16.0623H15.3666V17.3032C15.3666 19.0705 16.7579 19.2585 17.4912 19.4277C17.4912 19.4277 17.4912 20.1422 17.4912 20.161C16.9083 20.161 13.0917 20.161 12.5276 20.161C12.5276 20.161 12.5276 19.4465 12.5276 19.4277C13.2609 19.2773 14.6522 19.0893 14.671 17.322V16.0623H14.2197C14.2197 16.0623 14.2197 16.0623 14.2197 16.0811C14.2197 16.0999 14.2197 16.1375 14.2197 16.1563C14.2197 17.0776 13.4677 17.8484 12.5276 17.8484C11.7004 17.8484 11.0047 17.2468 10.8731 16.4571C10.8167 16.2879 10.8355 16.0623 10.8731 15.8367C10.9671 15.3854 11.1551 14.8966 11.3431 14.6146C11.738 13.9941 14.2197 10.7791 14.8214 10.0082H15.235C15.8367 10.7791 18.4313 14.1445 18.7509 14.6898C18.9953 15.0846 19.2961 15.7803 19.2397 16.2879"
      fill="#F9F9F9"
    />
  </svg>
</template>
